export default __webpack_public_path__ + "static/media/LLdcourseImg.12483234.svg";